import React from "react";
import styled from "styled-components"
import { UI_CAPTION_BOLD_DF, UI_CAPTION_DF } from "oolib";
import { LegendTooltipGlyph } from "./LegendTooltipGlyph";
import { StyledLabelHeader, StyledHorizontalLabel, StyledLegendItem } from "./styled"

export const StyledLegendContainer = styled.div<{ orientation: "vertical" | "horizontal" }>`
  border-radius: 8px;
  padding-top: 1.6rem;
  max-width: ${({ orientation }) => orientation === 'vertical' ? '200px' : 'none'};
  max-height: ${({ orientation }) => orientation === 'vertical' ? '100%' : '100px'};
`;

export const StyledItemsContainer = styled.div<{ orientation: "vertical" | "horizontal" }>`
  display: flex;
  flex-direction: ${({ orientation }) => orientation === 'vertical' ? 'column' : 'row'};
  flex-wrap: ${({ orientation }) => orientation === 'horizontal' ? 'wrap' : 'nowrap'};
  gap: 8px;
  padding: 0 1.6rem 1.6rem 1.6rem;
`;
interface LegendData {
  color: string;
  text: string;
}

interface LegendProps {
  data: LegendData[];
  label?: string;
  orientation?: "vertical" | "horizontal";
}

export const Legend: React.FC<LegendProps> = ({
  data,
  label,
  orientation = "vertical",
}) => {
  if(data?.length < 0 ) return null
  return (
    <StyledLegendContainer orientation={orientation}>
      {label && orientation === 'vertical' && (
        <StyledLabelHeader>
          <UI_CAPTION_BOLD_DF>{label}</UI_CAPTION_BOLD_DF>
        </StyledLabelHeader>
      )}
      
      <StyledItemsContainer orientation={orientation}>
        {label && orientation === 'horizontal' && (
          <StyledHorizontalLabel>{label}</StyledHorizontalLabel>
        )}
        
        {data?.map((item, index) => (
          <StyledLegendItem key={index}>
            <LegendTooltipGlyph color={item.color} />
            <UI_CAPTION_DF>{item.text}</UI_CAPTION_DF>
          </StyledLegendItem>
        ))}
      </StyledItemsContainer>
    </StyledLegendContainer>
  );
};
